import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto'
  },

  icon: {
    rotate: '90deg',
    cursor: 'pointer'
  },

  menu: {
    border: '1px solid #E6EAEC',
    borderRadius: '6px',
    boxSizing: 'border-box',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.04)',
    minWidth: '10rem',
    padding: '10px 13px',
    background: '#FFFFFF',
    overflow: 'hidden auto'
  }
}))

export default useStyles
